import Vue from 'vue';
import Vuex from 'vuex';
// import routesList from '@/store/modules/routesList.js';
// import tagsViewRoutes from '@/store/modules/tagsViewRoutes.js';
// import keepAliveNames from '@/store/modules/keepAliveNames.js';
// import userInfos from '@/store/modules/userInfos.js';
// import themeConfig from '@/store/modules/themeConfig.js';
import getters from './getters'

Vue.use(Vuex);

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
	// set './app.js' => 'app'
	const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
	const value = modulesFiles(modulePath)
	modules[moduleName] = value.default
	return modules
}, {})

const store = new Vuex.Store({
	modules,
	getters
})

export default store

// export default new Vuex.Store({
// 	modules: {
// 		routesList,
// 		tagsViewRoutes,
// 		keepAliveNames,
// 		userInfos,
// 		themeConfig,
// 		getters,
// 	},
// });
